import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";

const BASE = "https://webhook.harmonyalgo.com/api";

const Row = ({ subscription, formatDate }) => {
  const [tradingviewUsername, setTradingviewUsername] = useState(subscription.tradingview_username);
  const [discordUsername, setDiscordUsername] = useState(subscription.discord_username);

  const handleKeypress = async (e, id, platform, username) => {
    if (e.code === 'Enter') {
      const res = await fetch(`${BASE}/update_username`, {
        method: "POST",
        body: JSON.stringify({ id, platform, username }),
        headers: { "Content-Type": "application/json" },
      });
      const resJson = await res.json();
      console.log(resJson)
      alert(`New username: ${username}\nOld username: ${subscription.username}`)
    }
  }


  return (
    <tr
      key={subscription.id}
      className="hover:bg-zinc-800/50 transition-colors"
    >
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-800 text-zinc-100 border border-zinc-700">
          {subscription.subscription_id}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <input type="text" value={tradingviewUsername} onChange={(e) => { setTradingviewUsername(e.target.value) }} onKeyPress={(e) => {handleKeypress(e, subscription.id, 'tradingview', tradingviewUsername)}}/>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <input type="text" value={discordUsername} onChange={(e) => { setDiscordUsername(e.target.value) }} onKeyPress={(e) => {handleKeypress(e, subscription.id, 'discord', discordUsername)}}/>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-800 text-zinc-100 border border-zinc-700" title={subscription.payment_link}>
          {subscription.payment_link_label}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
          {subscription.email}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(subscription.created_at)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(subscription.end_date)}
      </td>
    </tr>
  );
};

const Subscriptions = ({ formatDate }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${BASE}/subscriptions`);
      const resJson = await res.json();
      setTableData(resJson);
    };
    fetchData();
  }, []);

  const filteredData = tableData.filter(
    (item) =>
      item.subscription_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.payment_link.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900">
      <div className="p-6 border-b border-zinc-800">
        <div className="flex items-center justify-between">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-zinc-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Search subscriptions..."
              className="pl-10 pr-4 py-2 w-80 bg-zinc-800 text-zinc-100 border border-zinc-700 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-600 focus:border-zinc-600 placeholder-zinc-400"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="text-sm text-zinc-400">
            {filteredData.length} subscriptions
          </div>
        </div>
      </div>

      {/* Tablo */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Subscription ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                TradingView Username
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Discord Username
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Payment Link
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Created At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                End Date
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {filteredData.map((subscription) => (
              <Row
                subscription={subscription}
                formatDate={formatDate}
              />
            ))}
            {filteredData.length ? null : (
              <td className="m-4 px-1 py-4 whitespace-nowrap text-sm text-zinc-100">
                No items.
              </td>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export { Subscriptions }

